export const description =
  "L'audit énergétique 2026 : étude obligatoire pour la vente des passoires thermiques (F/G/E) et pour le parcours accompagné MaPrimeRénov’. Conditions, coût, démarches et aides.";
